/// <reference path="../typings/index.d.ts" />
/// <reference path="Select2.d.ts" />

namespace App {
    export class Select2 implements ISelect2 {
        public inicializarCampo(el: any, options: any = null): void {
            if (options) {
                el.select2(options);
            } else {
                el.select2();
            }
        }
        public setSelectTag(elSelect: JQuery, data?: IDataSelectTagOptions) {
            if (elSelect.find("option[value='" + data.id + "']").length) {
                elSelect.val(data.id).trigger('change').trigger('select2:select');;
            } else {
                var newOption = new Option(data.text, data.id, true, true);
                elSelect.append(newOption).trigger('change').trigger('select2:select');;
            }
        }

    }
}
